<template>
    <Header></Header>
    <div class="LocationBar">
        <div class="inner">
            <ul class="Location">
                <li class="Location__item home"><a href="" class="Location__item--btn"><img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAABPklEQVQ4ja3TP0sDQRAF8J+HiGAKLQVFsbIQ4p/SRrDKB0hhZyXYiFjnQ9jZCJYigo2CRUDBNkr8ArGytRAUooVaZALHceeZ4IOFtzPz3s4uOyP1el0JFnAafAtPvxUnJWZ1tPEYqx2xQowWxMdxGB3t4CziNzjGJvbR/UuHi2hhDaspM8FXI9eK2l8Nt3GPJtbRyTmwE7lm1G6nk/0rV3CEmt41L3OM0vjEAW5xovcEu3hLsIwHzAcvM0vjMjTz4bGcROvn2MDzAGZ9PIf2HM0EM2jgAtUhDKuhbWB2FB+RmMNUjmAEK8Hb+M7kp0IL3aJ/2McErjOGNbwXCcomZVfvB0zHqkSsEGUdLuEKb7G/ilghyjqErwI+tOFA+HfD7BtWMJnaj+VoxjI1lSLDV/ljt5fiL3qzvpWpueuTH1quOlOE3j3aAAAAAElFTkSuQmCC"
                            alt="이미지"></a></li>
                <li class="Location__item"><a href="javascript:;" class="Location__item--btn">
                        <p>진료과/의료진</p><span></span>
                    </a>
                    <div class="Location__item--Layer">
                        <ul>
                            <li><a href="/hospital/department-doctor/department.do" class="">진료과/의료진</a></li>
                            <li><a href="/reserve/appointment.do" class="">예약/발급</a></li>
                            <li><a href="/hospital/information/outpatient.do" class="">이용안내</a></li>
                            <li><a href="/hospital/healthInfo/consulting.do" class="">건강정보</a></li>
                            <li><a href="/hospital/hospitalIntro/fatima/greetings.do" class="">병원소개</a></li>
                        </ul>
                    </div>
                </li>
                <li class="Location__item"><a href="javascript:;" class="Location__item--btn">
                        <p>진료과</p><span></span>
                    </a>
                    <div class="Location__item--Layer">
                        <ul>
                            <li><a href="/hospital/hospitalIntro/fatima/greetings.do" class="">창원파티마병원</a></li>
                            <li><a href="/hospital/hospitalIntro/story/newsBoard.do" class="">파티마이야기</a></li>
                            <li><a href="/hospital/hospitalIntro/active/prayBoard.do" class="">병원활동</a></li>
                        </ul>
                    </div>
                </li>
                <li class="Location__item">
                    <div class="Location__item--Layer">
                        <ul>
                            <li><a aria-current="page" href="/kr/news/list.do"
                                    class="router-link-active router-link-exact-active">화이팅</a></li>
                            <li><a href="/kr/press/list.do" class="">언론보도</a></li>
                            <li><a href="/kr/event/list.do" class="">행사안내</a></li>
                            <li><a href="/kr/job/list.do" class="">퍼블팀</a></li>
                            <li><a href="https://fliphtml5.com/bookcase/nrkwy/"
                                    to="https://fliphtml5.com/bookcase/nrkwy/"></a></li>
                            <li><a href="/kr/gallery/list.do" class=""></a></li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="container">
        <div class="sub-tit">
            <h2>의료진검색</h2>
        </div>
        <div class="inner">
            <div class="tab-menu type02">
        <ul class="tab-menu__list">
            <li class="tab-menu__item"><button type="button" class="tab-menu__btn">진료과 안내</button></li>
            <li class="tab-menu__item"><button type="button" class="tab-menu__btn on">의료진 검색</button></li>
            <li class="tab-menu__item"><button type="button" class="tab-menu__btn">센터&클리닉</button></li>
            <li class="tab-menu__item"><button type="button" class="tab-menu__btn">진료일정표</button></li>
        </ul>
    </div>
    <div class="board__search">
        <div class="board__select">
            <select name="" id="Sel_Inst" class="select_department">
                <option value="">진료과</option>
                <option value="">진료과 예시</option>
                <option value="">진료과 예시</option>
            </select>
        </div>
        <div class="board__select">
            <select name="" id="Sel_Inst" class="select_department">
                <option value="">전체</option>
                <option value="title">제목</option>
                <option value="content">내용</option>
            </select>
        </div>
        <div class="board__input">
            <input type="text" id="Search_doc" placeholder="의료진 이름을 입력하세요.">
            <button type="button" class="board__input-btn"></button>
        </div>
    </div>
    <div class="initial-search">
        <h3>초성검색</h3>
        <ul class="initial-search__list">
            <li><a href="javascript:;" class="all active">ALL</a></li>
            <li><a href="javascript:;">ㄱ</a></li>
            <li><a href="javascript:;">ㄴ</a></li>
            <li><a href="javascript:;">ㄷ</a></li>
            <li><a href="javascript:;">ㄹ</a></li>
            <li><a href="javascript:;">ㅁ</a></li>
            <li><a href="javascript:;">ㅂ</a></li>
            <li><a href="javascript:;">ㅅ</a></li>
            <li><a href="javascript:;">ㅇ</a></li>
            <li><a href="javascript:;">ㅈ</a></li>
            <li><a href="javascript:;">ㅊ</a></li>
            <li><a href="javascript:;">ㅋ</a></li>
            <li><a href="javascript:;">ㅌ</a></li>
            <li><a href="javascript:;">ㅍ</a></li>
            <li><a href="javascript:;">ㅎ</a></li>
        </ul>
    </div>


    <div class="contents">
        <ul class="doctor-list">
            <li class="doctor-list__item">
                <div class="doctor-list--img">
                    <img src="@/assets/resource/img/profile-sample3.png" alt="이미지">
                </div>
                <div class="doctor-list--con">
                    <div class="doctor-list--text">
                        <a href="javascript:;" class="doctor-list--heart"></a>
                        <h3>마상혁<sub>소아청소년과</sub></h3>
                        <h4>주진료분야</h4>
                        <p>건강증진센터 상·하부 소화기내시경</p>
                    </div>
                    <div class="doctor-list--button">
                        <a href="javascript:;">의료진소개</a>
                        <a href="javascript:;">진료예약</a>
                    </div>
                </div>
            </li>
            <li class="doctor-list__item">
                <div class="doctor-list--img">
                    <img src="@/assets/resource/img/profile-sample3_2.png" alt="이미지">
                </div>
                <div class="doctor-list--con">
                    <div class="doctor-list--text">
                        <a href="javascript:;" class="doctor-list--heart"></a>
                        <h3>신재욱<sub>소화기내과</sub></h3>
                        <h4>주진료분야</h4>
                        <p>만성기침, 기관지 천식 및 알러지성 기도질환,
                            만성폐쇄성폐질환, 폐암, 폐렴 및 폐결핵</p>
                    </div>
                    <div class="doctor-list--button">
                        <a href="javascript:;">의료진소개</a>
                        <a href="javascript:;">진료예약</a>
                    </div>
                </div>
            </li>
            <li class="doctor-list__item">
                <div class="doctor-list--img">
                    <img src="@/assets/resource/img/profile-sample3_3.png" alt="이미지">
                </div>
                <div class="doctor-list--con">
                    <div class="doctor-list--text">
                        <a href="javascript:;" class="doctor-list--heart"></a>
                        <h3>윤성한<sub>신장내과</sub></h3>
                        <h4>주진료분야</h4>
                        <p>류마티스관절염, 전신홍반루푸스,
강직성 척추염, 쇼그렌증후군, 통풍, 베체트병,
자가면역질환, 섬유근통</p>
                    </div>
                    <div class="doctor-list--button">
                        <a href="javascript:;">의료진소개</a>
                        <a href="javascript:;">진료예약</a>
                    </div>
                </div>
            </li>
            <li class="doctor-list__item">
                <div class="doctor-list--img">
                    <img src="@/assets/resource/img/profile-sample3_4.png" alt="이미지">
                </div>
                <div class="doctor-list--con">
                    <div class="doctor-list--text">
                        <a href="javascript:;" class="doctor-list--heart"></a>
                        <h3>이일수<sub>심장내과</sub></h3>
                        <h4>주진료분야</h4>
                        <p>주진료분야
                            중환자의학</p>
                    </div>
                    <div class="doctor-list--button">
                        <a href="javascript:;">의료진소개</a>
                        <a href="javascript:;">진료예약</a>
                    </div>
                </div>
            </li>
            <li class="doctor-list__item">
                <div class="doctor-list--img">
                    <img src="@/assets/resource/img/profile-sample3.png" alt="이미지">
                </div>
                <div class="doctor-list--con">
                    <div class="doctor-list--text">
                        <a href="javascript:;" class="doctor-list--heart"></a>
                        <h3>마상혁<sub>소아청소년과</sub></h3>
                        <h4>주진료분야</h4>
                        <p>건강증진센터 상·하부 소화기내시경</p>
                    </div>
                    <div class="doctor-list--button">
                        <a href="javascript:;">의료진소개</a>
                        <a href="javascript:;">진료예약</a>
                    </div>
                </div>
            </li>
            <li class="doctor-list__item">
                <div class="doctor-list--img">
                    <img src="@/assets/resource/img/profile-sample3_2.png" alt="이미지">
                </div>
                <div class="doctor-list--con">
                    <div class="doctor-list--text">
                        <a href="javascript:;" class="doctor-list--heart"></a>
                        <h3>신재욱<sub>소화기내과</sub></h3>
                        <h4>주진료분야</h4>
                        <p>만성기침, 기관지 천식 및 알러지성 기도질환,
                            만성폐쇄성폐질환, 폐암, 폐렴 및 폐결핵</p>
                    </div>
                    <div class="doctor-list--button">
                        <a href="javascript:;">의료진소개</a>
                        <a href="javascript:;">진료예약</a>
                    </div>
                </div>
            </li>
            <li class="doctor-list__item">
                <div class="doctor-list--img">
                    <img src="@/assets/resource/img/profile-sample3_3.png" alt="이미지">
                </div>
                <div class="doctor-list--con">
                    <div class="doctor-list--text">
                        <a href="javascript:;" class="doctor-list--heart"></a>
                        <h3>윤성한<sub>신장내과</sub></h3>
                        <h4>주진료분야</h4>
                        <p>류마티스관절염, 전신홍반루푸스,
강직성 척추염, 쇼그렌증후군, 통풍, 베체트병,
자가면역질환, 섬유근통</p>
                    </div>
                    <div class="doctor-list--button">
                        <a href="javascript:;">의료진소개</a>
                        <a href="javascript:;">진료예약</a>
                    </div>
                </div>
            </li>
            <li class="doctor-list__item">
                <div class="doctor-list--img">
                    <img src="@/assets/resource/img/profile-sample3_4.png" alt="이미지">
                </div>
                <div class="doctor-list--con">
                    <div class="doctor-list--text">
                        <a href="javascript:;" class="doctor-list--heart"></a>
                        <h3>이일수<sub>심장내과</sub></h3>
                        <h4>주진료분야</h4>
                        <p>주진료분야
                            중환자의학</p>
                    </div>
                    <div class="doctor-list--button">
                        <a href="javascript:;">의료진소개</a>
                        <a href="javascript:;">진료예약</a>
                    </div>
                </div>
            </li>
        </ul>
        <div class="paging"><!--v-if--><!--v-if--><a class="board__pagination-btn num on" href="javascript:;">1</a><a
                class="board__pagination-btn num" href="javascript:;">2</a><a class="board__pagination-btn num"
                href="javascript:;">3</a><a class="board__pagination-btn num" href="javascript:;">4</a><a
                class="board__pagination-btn num" href="javascript:;">5</a><a class="board__pagination-btn num"
                href="javascript:;">6</a><a class="board__pagination-btn num" href="javascript:;">7</a><a
                class="board__pagination-btn num" href="javascript:;">8</a><a class="board__pagination-btn num"
                href="javascript:;">9</a><a class="board__pagination-btn num" href="javascript:;">10</a><a
                href="javascript:;" class="board__pagination-btn next">다음 페이지</a><a href="javascript:;"
                class="board__pagination-btn last">마지막 페이지</a></div>
    </div>
        </div>
    </div>
    <!-- container -->
    <Footer></Footer>
</template>

<script>
    import Header from '@/components/common/Header.vue';
    import LocationBar from '@/components/common/LocationBar.vue';
    import Footer from '@/components/common/Footer.vue';

    export default {
        components: {
            Header,
            LocationBar,
            Footer
        },
        mounted() {
            console.log(123)
        },
    }
</script>
<style>
    /* @import url('../../assets/resource/css/sub.css'); */
</style>

